import React from 'react';
import BackButton from '../../../components/BackButton';
import Button from '../../../components/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Colors from '../../Colors';
import ConditionsQueryBuilderEngine from '../../../components/conditions-query-builder/engine/ConditionsQueryBuilderEngine';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import _DeleteIcon from '@material-ui/icons/Delete';
import GeneralDialog from '../../GeneralDialog';
import IconButton from '@material-ui/core/IconButton';
import InitialsBadge from '../../../components/InitialsBadge';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import { Options } from '../../../components/conditions-query-builder/view/ConditionsQueryBuilderView';
import OTGreyCard from '../../../components/containers/cards/OTGreyCard';
import Select from '@material-ui/core/Select';
import SelectEngine from '../../../components/engine/SelectEngine';
import SlimLineCard from '../../../components/containers/cards/SlimLineCard';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import _InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';

const SectionContainerCSS = `
    margin-top: 0.8rem;
`;

const cardCSS = `
  h2 {
    margin: 0;
    margin-left: 0.8rem;
    font-size: 18px;
  }

  svg {
    color: #c8c8c8;
  }

`;

const InfoIcon = styled(_InfoIcon)`
  margin-left: 1rem;
  vertical-align: middle;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.8rem;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TopControls = styled.div`
  display: flex;
`;

const DeleteButton = styled(IconButton)`
  margin-left: auto !important;
`;

const DeleteIcon = styled(_DeleteIcon)`
  color: ${Colors.OT_RED};
`;

const H2 = styled.h2`
  margin: 0.8rem 0;
  font-size: 18px;
  font-weight: 500;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 0 0 0;
`;

const SectionContainer = props => {
  return <OTGreyCard $css={SectionContainerCSS} {...props} />;
};

const StyledSelect = styled(Select)`
  background-color: #fff;
  border: 1px solid #bfc5d1;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 30px;
  margin: 1rem;
  padding: 0.1em 1.3em 0.1em 0.8em;
  position: relative;
  &&:before,
  &&:after {
    border-bottom: !important;
    content: none;
  }
  &&:hover {
    border: 1px solid #000;
  }
  & > svg {
    color: #000 !important;
    right: 0.5em !important;
    top: 0 !important;
  }
`;

const NotificationDropDown = styled(SelectEngine)`
  margin-left: 1rem !important;
`;

const FormBuilderCollaborateWizardView = props => {
  const t = useTranslations();
  const nameText =
    props.editMode && props.showingCollaboratorValue
      ? '' +
        props.showingCollaboratorValue.firstName +
        ' ' +
        props.showingCollaboratorValue.lastName
      : '';
  const emailText =
    props.editMode && props.showingCollaboratorValue
      ? '' + props.showingCollaboratorValue.email
      : '';
  return (
    <Container>
      <TopControls>
        <BackButton onClick={props.onCancel} size="small" />
        {props.editMode ? (
          <DeleteButton onClick={props.onDelete} size="small">
            <DeleteIcon />
          </DeleteButton>
        ) : (
          ''
        )}
      </TopControls>
      <SectionContainer>
        {props.editMode ? (
          <SlimLineCard $rounded $css={cardCSS}>
            <span>
              <InitialsBadge
                firstName={props.showingCollaboratorValue.firstName || ''}
                lastName={props.showingCollaboratorValue.lastName || ''}
              />
            </span>
            <UserInfo>
              <b>{nameText}</b>
              <small>{emailText}</small>
            </UserInfo>
          </SlimLineCard>
        ) : (
          <>
            <H2>
              {t('form-builder.admins.select_user')}
              <Tooltip title={t('form-builder.admins.warning_two')}>
                <InfoIcon />
              </Tooltip>
            </H2>
            <SelectEngine
              searchable
              data-testid="formbuilder-collaborate-select-admin"
              value={props.showingCollaboratorValue}
              valueParser={val => (val && val.value ? val.value : val)}
              openMenuOptionParser={props.openMenuOptionParser}
              placeholder={
                props.showingCollaboratorValue.value
                  ? `${props.showingCollaboratorValue.firstName} ${props.showingCollaboratorValue.lastName}`
                  : t('form-builder.admins.start_typing')
              }
              onChange={props.changedDropdown}
              asyncOptions={props.loadOptions}
              customCSS={`transition: 0.2s; width: 470px; ${props.isSaveBtnDisabled()}
            ) && 'border: 2px solid #4c84ff !important;'}`}
            />
          </>
        )}
      </SectionContainer>
      <SectionContainer>
        <H2>{t('form-builder.admins.admin_permissions')}</H2>
        <div>
          {t('form-builder.admins.admin_can_view1')}
          <StyledSelect
            data-testid={`formbuilder-collaborate-view-and-manage`}
            value={props.viewOnly}
            onChange={props.onViewOnlyChanged}
            renderValue={value => {
              if (!value) {
                return 'View and Manage';
              }
              return 'View';
            }}
            inputProps={{
              'data-testid': 'select-view-and-manage'
            }}
            SelectDisplayProps={{
              'data-testid': 'select-view-and-manage-div'
            }}
          >
            <MenuItem
              value={false}
              key={'select-view-and-manage'}
              data-testid={'formbuilder-collaborate-select-view-and-manage'}
            >
              View and Manage
            </MenuItem>
            <MenuItem
              value={true}
              key={'select-view'}
              data-testid={'formbuilder-collaborate-select-view'}
            >
              View
            </MenuItem>
          </StyledSelect>
          {t('form-builder.admins.admin_can_view2')}
          <StyledSelect
            data-testid={`formbuilder-collaborate-select-group`}
            value={
              props.selectedGroups && props.selectedGroups.length
                ? props.selectedGroups
                : ['all']
            }
            onChange={props.changedGroupSelection}
            renderValue={value => {
              var firstLabel, matches;
              firstLabel = '';

              if (!value || !value.length) {
                return '';
              }
              if (props.allGroups && props.allGroups.length) {
                matches = props.allGroups.filter(one => one.value === value[0]);
                if (matches && matches.length) {
                  firstLabel = matches[0].label;
                }
              }
              if (value.length === 1 && value[0] === 'all') {
                return t('form-builder.groups.all');
              } else if (value.length === 1) {
                return firstLabel;
              } else {
                return firstLabel + ' (+' + (value.length - 1) + ')';
              }
            }}
            inputProps={{
              'data-testid': 'select-groups'
            }}
            SelectDisplayProps={{
              'data-testid': 'select-groups-div'
            }}
            multiple
            disabled={props.isPublicForm}
          >
            <MenuItem
              value="all"
              key={'select-groups-all'}
              data-testid={'formbuilder-collaborate-select-groups-allgroups'}
            >
              <Checkbox
                checked={Boolean(
                  props.selectedGroups &&
                    (props.selectedGroups.indexOf('all') !== -1 ||
                      props.selectedGroups.length === 0)
                )}
              />
              <ListItemText primary={t('form-builder.groups.all')} />
            </MenuItem>
            {props.allGroups.map(group => (
              <MenuItem
                data-testid={
                  'formbuilder-collaborate-select-groups-' + group.label
                }
                key={'select-group-' + group.label}
                value={group.value}
              >
                <Checkbox
                  checked={Boolean(
                    props.selectedGroups &&
                      props.selectedGroups.indexOf(group.value) !== -1
                  )}
                />
                <ListItemText primary={group.label} />
              </MenuItem>
            ))}
          </StyledSelect>
        </div>
        <ConditionsQueryBuilderEngine
          backEndConditions={props.query}
          // deleteSection={() => removeCondition(id)}
          form={props.form}
          update={props.updateQuery}
          filter={[Options.RESPONSIBLE_ADMIN, Options.DATE_RANGE]}
          useSpacers
        />
      </SectionContainer>
      <SectionContainer>
        <H2>{t('form-builder.admins.admin_notify_section')}</H2>
        <div>
          {t('form-builder.admins.admin_notify')}
          <NotificationDropDown
            value={props.notificationType}
            onChange={props.changedNotificationDropdown}
            options={[
              {
                text: 'form-builder.admins.admin_new_submissions',
                value: 'ALWAYS',
                'data-testid': 'form-builder.admins.admin_new_submissions'
              },
              {
                text: 'form-builder.admins.admin_flagged_submissions',
                value: 'FLAGGED_ONLY',
                'data-testid': 'form-builder.admins.admin_flagged_submissions'
              },
              {
                text: 'form-builder.admins.admin_responsible_submissions',
                value: 'ASSIGNED_ONLY',
                'data-testid':
                  'form-builder.admins.admin_responsible_submissions'
              }
            ]}
          />
        </div>
      </SectionContainer>
      <ButtonsContainer>
        <Button disabled={props.isSaveBtnDisabled()} onClick={props.onSave}>
          {t('form-builder.admins.confirm')}
        </Button>
      </ButtonsContainer>
      <GeneralDialog
        open={props.warningDialogOpen}
        handleClose={() => {
          props.setWarningDialogOpen(false);
        }}
        handleConfirm={props.confirmChangingGroup}
        title="warnings.deleting_assignee.title"
        content="warnings.deleting_assignee"
      />
    </Container>
  );
};

export default FormBuilderCollaborateWizardView;
